/**
 * Product Inventory Handler
 * Handles inventory-based button text updates for pre-order functionality
 */

class ProductInventoryHandler {
  constructor() {
    this.inventoryData = null;
    this.currentVariantId = null;
    this.init();
  }

  init() {
    // Get inventory data from the page
    const inventoryDataElement = document.querySelector('[data-product-inventory-data]');
    if (inventoryDataElement) {
      try {
        this.inventoryData = JSON.parse(inventoryDataElement.textContent);
        this.setupEventListeners();
        this.setupPeriodicCheck();
      } catch (error) {
        console.error('ProductInventoryHandler: Error parsing inventory data:', error);
      }
    } else {
      console.log('ProductInventoryHandler: No inventory data found on page');
    }
  }

  setupEventListeners() {
    // Listen for variant interactions from swatches (including clicks on already selected variants)
    document.addEventListener('click', (event) => {
      const swatch = event.target.closest('.product__color-swatch.dynamic-variant-button');
      if (swatch) {
        // Use a small delay to ensure the variant selection has been processed
        setTimeout(() => {
          this.handleVariantChange();
        }, 10);
      }
    });

    // Listen for variant changes from select dropdowns
    document.addEventListener('change', (event) => {
      const select = event.target;
      if (select.name === 'options[inhoud]' || select.id === 'option1' || select.name === 'id') {
        this.handleVariantChange();
      }
    });

    // Listen for custom variant change events
    document.addEventListener('product:variant-change', () => {
      this.handleVariantChange();
    });

    // Listen for any clicks on variant-related elements
    document.addEventListener('click', (event) => {
      const target = event.target;
      // Check for various variant selector patterns
      if (target.matches('[data-variant-id], [data-option-value], .variant-option, .option-value')) {
        setTimeout(() => {
          this.handleVariantChange();
        }, 10);
      }
    });

    // Listen for any form changes that might affect variants
    document.addEventListener('change', (event) => {
      const target = event.target;
      // Check for any form elements that might be related to variants
      if (target.matches('input[name*="option"], select[name*="option"], input[data-option]')) {
        setTimeout(() => {
          this.handleVariantChange();
        }, 10);
      }
    });
  }

  handleVariantChange() {
    // Get current variant ID from the form
    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect) {
      const newVariantId = variantSelect.value;
      // Always update the button text, even if the variant ID hasn't changed
      // This handles cases where the same variant is clicked again
      this.currentVariantId = newVariantId;
      this.updateButtonText();
    }
  }

  updateButtonText() {
    if (!this.inventoryData || !this.currentVariantId) return;

    const variant = this.inventoryData.variants[this.currentVariantId];
    if (!variant) return;

    // Find all add to cart buttons
    const addToCartButtons = document.querySelectorAll('[data-add-to-cart]');
    
    addToCartButtons.forEach(button => {
      const textElement = button.querySelector('[data-add-to-cart-text]');
      if (!textElement) return;

      let buttonText = '';

      if (!variant.available) {
        // Product is not available
        buttonText = button.dataset.langSoldOut || 'Sold Out';
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');
      } else {
        // Product is available
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');

        // Check for pre-order condition
        if (variant.inventory_quantity <= 0 && variant.inventory_policy === 'continue' && variant.metafields?.Verkoopstatus?.value === 'Pre-order') {
          buttonText = button.dataset.langPreorder || 'Pre-order';
        } else {
          buttonText = button.dataset.langAvailable || 'Add to Cart';
        }
      }

      textElement.textContent = buttonText;
    });
  }

  // Public method to manually trigger update
  update() {
    this.handleVariantChange();
  }

  // Force update button text based on current variant
  forceUpdate() {
    if (this.inventoryData) {
      this.updateButtonText();
    }
  }

  setupPeriodicCheck() {
    // Check every 2 seconds to ensure button text is correct
    // This helps catch any cases where other scripts might interfere
    setInterval(() => {
      if (this.inventoryData && this.currentVariantId) {
        this.updateButtonText();
      }
    }, 2000);
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new ProductInventoryHandler();
});

// Also initialize immediately if DOM is already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductInventoryHandler();
  });
} else {
  new ProductInventoryHandler();
} 